<template>
  <div class="lib__form__main" data-cy="contact-component">
    <ValidationObserver ref="validator" slim>
      <div class="lib__form__main__content">
        <header class="lib__form__main__header">
          <h2 class="lib__h2">{{ $t('contact.title') }}</h2>
        </header>

        <contact-info-form :address="addressState" :value="contactInfo"></contact-info-form>

        <error-message name="contactInfo"></error-message>
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Inject, Watch, Prop } from 'vue-property-decorator'
import Step from '@/components/steps/Step'
import ContactInfoForm from '@/components/inputs/Contact/ContactInfoForm.vue'
import { State, Mutation } from 'vuex-class'
import { ContactInfo, AddressPoint } from '@/models'
import { helper, contactService } from '@/services'

@Component({
  name: 'contact-info-step',
  components: {
    ContactInfoForm
  }
})
export default class ContactInfoStep extends Step {
  //#region [Data]
  @State('requestId', { namespace: 'synergridConnection' })
  public requestId!: string
  @State('address', { namespace: 'synergridConnection/address' })
  public addressState!: AddressPoint | null

  @State('contactInfo', { namespace: 'synergridConnection/contactInfo' })
  public contactInfoState!: ContactInfo | null

  public contactInfo: ContactInfo = contactService.createContactInfo()
  //#endregion

  //#region [Mutation]
  @Mutation('STORE', { namespace: 'synergridConnection/contactInfo' })
  private store!: (index: ContactInfo | null) => void
  //#endregion

  //#region [Watch]
  public onStateChanged(state: ContactInfo | null) {
    if (state !== null) {
      this.contactInfo = helper.clone(state)
    }
  }
  //#endregion

  //#region [Method]
  public mounted() {
    this.setIsBack(false)
    this.onStateChanged(this.contactInfoState)
  }

  public async save(next: boolean, isValid: boolean) {
    if (isValid) {
      this.$appInsights.trackEvent('WR_SC_StepContact_Validated', {
        Segment: 'WR_SC',
        WebRef: this.requestId
      })
    }

    this.store(this.contactInfo)
  }
  //#endregion
}
</script>